import React, { createContext, useState } from 'react';

import { StatusResult, SupplyResult } from '@block-explorer/entities';

export type GlobalState = {
  status: {
    data: StatusResult | null;
    error: string | null;
  };
  supply: {
    data: SupplyResult | null;
    error: string | null;
  };
};

const initialGlobalState: GlobalState = {
  supply: { data: null, error: null },
  status: { data: null, error: null },
};

type GlobalStateKey = keyof GlobalState;

export type StatusState = {
  data: StatusResult | null;
  error: string | null;
};

type CacheContext = {
  getGlobalState: <Key extends GlobalStateKey>(key: Key) => GlobalState[Key];
  setGlobalState: (
    state: GlobalState | ((prevState: GlobalState) => GlobalState)
  ) => void;
};

export const cacheServiceContext = createContext<CacheContext>({} as any);

const { Provider: CacheContextProvider } = cacheServiceContext;

export const CacheProvider = (props) => {
  const [globalState, setGlobalState] =
    useState<GlobalState>(initialGlobalState);

  const getGlobalState = (key: GlobalStateKey) => globalState[key];

  const contextProps = {
    getGlobalState,
    setGlobalState,
  };

  return <CacheContextProvider value={contextProps} {...props} />;
};
